module.exports = __webpack_public_path__ + "empresario.svg?641aa3330200aa7c310834836d2fc521";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresario.svg
// module id = 460
// module chunks = 0